module.exports = __webpack_public_path__ + "hyperion-v2-static/img/pulse_gauge_explainer.5d85d2da.png";